import useLazyData from '@/hooks/useLazyData';
import Skeleton from './skeleton';
import Container from '../Layout/container';
import CouponLine from './coupon-line';

const MkplCouponList = props => {
  const { useSkeleton = true } = props;
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = (
    <Container cmsComponentKey={props.cmsComponentKey} className="overflow-hidden">
      <Skeleton />
    </Container>
  );

  if (!useSkeleton) {
    return <CouponLine skeleton={skeleton} {...props} />;
  }

  return <div ref={viewRef}>{show ? <CouponLine skeleton={skeleton} {...props} /> : skeleton}</div>;
};

export default MkplCouponList;
